import axios from "axios"
import qs from "qs"

export const getRouteData = (route: string, queryString: string) =>
  axios
    .get(route, { params: qs.parse(queryString) })
    .then((res) => res.data.data)
